<script>
import options from './PersonalFundraisingShareOverlay.options'
export default options
</script>

<template>
  <div class="kb-overlay-styles__content-wrapper">
    <article class="kb-overlay-styles kb-personal-fundraising-share-overlay">
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">
        <div class="kb-overlay-styles__hero">
          <div class="kb-overlay-styles__hero-wrapper">
            <h2 class="kb-overlay-styles__hero-title">{{ title }}</h2>

            <div class="kb-overlay-styles__hero-breaker">
              <svg
                viewBox="0 0 81 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" />
              </svg>
            </div>

            <div
              v-if="description"
              class="kb-overlay-styles__hero-description"
            >
              <p class="kb-overlay-styles__hero-description-text">{{ description }}</p>
            </div>
          </div>
        </div>

        <div class="kb-overlay-styles__hero-curve">
          <div class="kb-personal-fundraising-share-overlay__hero-curve-color-wrapper">
            <div class="kb-personal-fundraising-share-overlay__hero-curve-color-filler"></div>

            <svg
              role="presentation"
              viewBox="0 0 720 77"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
            </svg>
          </div>
        </div>

        <div class="kb-overlay-styles__form-content">
          <ul class="kb-personal-fundraising-share-overlay__list">
            <li
              v-for="link in shareLinks"
              :key="link.id"
            >
              <a
                class="kb-personal-fundraising-share-overlay__item"
                :href="link.href"
                :target="link.target"
                :rel="link.rel"
              >
                <span
                  class="kb-personal-fundraising-share-overlay__icon kb-ui-icon"
                  :class="link.iconClass"
                  aria-hidden="true"
                ></span>
                <span class="kb-personal-fundraising-share-overlay__item-text">{{ link.label }}</span>
              </a>
            </li>

            <li>
              <button
                type="button"
                class="kb-personal-fundraising-share-overlay__item"
                @click="copyShareLink"
              >
                <span
                  class="kb-personal-fundraising-share-overlay__icon kb-personal-fundraising-share-overlay__icon--disc"
                  aria-hidden="true"
                >
                  <svg
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    focusable="false"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.32818 6.67089L7.99672 6.33944L8.32818 6.00798L8.65963 6.33944C9.48339 7.1632 9.48339 8.49878 8.65963 9.32254L5.34507 12.6371C4.52131 13.4609 3.18572 13.4609 2.36196 12.6371C1.5382 11.8133 1.5382 10.4778 2.36196 9.654L4.68216 7.33381L5.01361 7.66526L2.69342 9.98546C2.05271 10.6262 2.05271 11.6649 2.69342 12.3057C3.33412 12.9464 4.37291 12.9464 5.01361 12.3057L8.32818 8.99109C8.96888 8.35038 8.96888 7.3116 8.32818 6.67089Z"
                      fill="currentColor"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.67089 8.32818L7.00235 8.65963L6.67089 8.99109L6.33944 8.65963C5.51568 7.83587 5.51568 6.50029 6.33944 5.67652L9.654 2.36196C10.4778 1.5382 11.8133 1.5382 12.6371 2.36196C13.4609 3.18572 13.4609 4.52131 12.6371 5.34507L10.3169 7.66526L9.98546 7.33381L12.3057 5.01361C12.9464 4.37291 12.9464 3.33412 12.3057 2.69342C11.6649 2.05271 10.6262 2.05271 9.98546 2.69342L6.6709 6.00798C6.03019 6.64869 6.03019 7.68747 6.67089 8.32818Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span class="kb-personal-fundraising-share-overlay__item-text">{{ copyLinkLabel }}</span>
              </button>
            </li>
          </ul>

          <p
            v-if="showCopiedMessage"
            class="kb-personal-fundraising-share-overlay__copied"
            aria-live="polite"
          >
            {{ linkCopiedLabel }}
          </p>

          <a
            v-if="campaignUrl"
            class="kb-personal-fundraising-share-overlay__go"
            :href="campaignUrl"
          >
            <span>{{ goToCollectionLabel }}</span>
            <span
              class="kb-ui-icon kb-ui-icon--ui-link"
              aria-hidden="true"
            ></span>
          </a>
        </div>
      </div>
    </article>
  </div>
</template>
